import React from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import { Login } from './components/Login';
import { Layout } from './components/Layout';
import { AdminDashboard } from './pages/AdminDashboard';
import { ReceptionDashboard } from './pages/ReceptionDashboard';
import { NursingDashboard } from './pages/NursingDashboard';
import { ClinicianDashboard } from './pages/ClinicianDashboard';
import { LaboratoryDashboard } from './pages/LaboratoryDashboard';
import { RadiologyDashboard } from './pages/RadiologyDashboard';
import { PharmacyDashboard } from './pages/PharmacyDashboard';
const MainApp = () => {
  const {
    user
  } = useAuth();
  if (!user) {
    return <Login data-id="element-0" />;
  }
  const renderDashboard = () => {
    switch (user.role) {
      case 'Administrator':
        return <AdminDashboard data-id="element-1" />;
      case 'Reception':
        return <ReceptionDashboard data-id="element-2" />;
      case 'Nursing':
        return <NursingDashboard data-id="element-3" />;
      case 'Clinician':
        return <ClinicianDashboard data-id="element-4" />;
      case 'Laboratory':
        return <LaboratoryDashboard data-id="element-5" />;
      case 'Radiology':
        return <RadiologyDashboard data-id="element-6" />;
      case 'Pharmacy':
        return <PharmacyDashboard data-id="element-7" />;
      default:
        return <div data-id="element-8">Unknown Role</div>;
    }
  };
  return <Layout data-id="element-9">{renderDashboard()}</Layout>;
};
export function App() {
  return <DataProvider data-id="element-10">
      <AuthProvider data-id="element-11">
        <MainApp data-id="element-12" />
      </AuthProvider>
    </DataProvider>;
}